export default __webpack_public_path__ + "static/media/bootstrap-reboot.min.css.c30ab006.map";